<template>
    <div>
        <van-popup class="login-popup" v-model="isShowLoginTel" :close-on-click-overlay="false" get-container="body">
            <div class="login-container">
                <div class="title">手机号登录</div>
                <div class="tel-code">
                    <div class="item">
                        <input v-model="telNo" placeholder="请输入您的手机号" />
                    </div>
                    <div class="item">
                        <input v-model="code" @input="onCodeChange" placeholder="请输入验证码" />
                        <div class="code-btn" :class="hasGetCode ? '' : 'disabled-state'" @click="onCheckTel">
                            {{ hasGetCode ? '获取验证码' : `${timeNum}s` }}
                        </div>
                    </div>
                    <div class="login-btn" @click="onLogin">登录</div>
                </div>
            </div>
        </van-popup>
        <van-popup class="verification-popup" v-model="isShowVerification" get-container="body">
            <div class="container">
                <img
                    v-if="isShowVerification"
                    @click="onResetNum"
                    class="verification-img"
                    :src="`${numVerificationUrl}${telNo}&rd=${numVerificationRd}`"
                />
                <van-icon @click="onResetNum" name="replay" />
                <input v-model="numVerification" placeholder="请输入" />
            </div>
            <div class="opts">
                <div class="close-btn btn-style1" @click="isShowVerification = false">取消</div>
                <div class="submit-btn btn-style1" @click="onSubmit">确认</div>
            </div>
        </van-popup>
    </div>
</template>
<script>
// 单独引入 防止其他地方没有引入
import { Popup, Icon } from 'vant'
import { urlQuery, isWeixin } from '@/utils/utils.js'
import { getOAuthTpTicket, userLogin, getCaptcha, loginByCaptcha } from '@/utils/api.js'
import { getUserInfo, setUserInfo, wxLogin } from '@/utils/login.js'

let timer = null
const setIntervalTime = 60
export default {
    components: { VanPopup: Popup, VanIcon: Icon },
    data() {
        return {
            isShowLoginTel: false,
            telNo: '',
            code: '',
            hasGetCode: true,
            timeNum: setIntervalTime,

            isShowVerification: false,
            numVerificationUrl: '',
            numVerification: '',
            numVerificationRd: 1,
        }
    },
    mounted() {
        const options = urlQuery()
        const userInfo = getUserInfo()
        if (isWeixin()) {
            // isLoginState 防止用户带有复制的 tpTicket 打开页面
            const state = window.localStorage.getItem('isLoginState')
            if (!state) {
                options.tpTicket = ''
            }
            if (!userInfo && !options.tpTicket) {
                this.getOAuthTpTicketApi()
            } else if (options.tpTicket && !userInfo) {
                this.loginByAuthTicketApi(options.tpTicket)
                window.localStorage.removeItem('isLoginState')
            }
        } else {
            this.numVerificationUrl = `${window.SEVER_PATH}/user/getKaptcha?tel=`
            this.isShowLoginTel = true
        }
    },
    methods: {
        onCheckTel() {
            const rule = new RegExp(/^1[0-9]{10}$/)
            if (!rule.test(this.telNo)) {
                return this.$toast('请输入正确的手机号')
            }
            if (!this.hasGetCode) return
            this.isShowVerification = true
        },
        onLogin() {
            const ruleTel = new RegExp(/^1[0-9]{10}$/)
            const ruleCode = new RegExp(/^[0-9]{4,8}$/)
            if (!ruleTel.test(this.telNo)) {
                return this.$toast('请输入正确的手机号')
            } else if (!ruleCode.test(this.code)) {
                return this.$toast('请输入正确的验证码')
            }
            loginByCaptcha({ tel: this.telNo, captcha: this.code }).then((res) => {
                this.$toast.success('登录成功')
                setUserInfo(res.data)
                this.$emit('authSuccess', res.data)
                this.isShowVerification = false
                this.isShowLoginTel = false
            })
        },
        onCodeChange() {
            this.code = this.code.substr(0, 6)
        },
        onResetNum() {
            this.numVerificationRd += 1
        },
        onSubmit() {
            getCaptcha({ tel: this.telNo, kaptcha: this.numVerification }).then(() => {
                this.isShowVerification = false
                this.$toast.success('发送成功')
                this.hasGetCode = false
                timer = setInterval(() => {
                    this.timeNum -= 1
                    if (this.timeNum <= 0) {
                        clearInterval(timer)
                        timer = null
                        this.hasGetCode = true
                        this.timeNum = setIntervalTime
                    }
                }, 1000)
            })
        },
        getOAuthTpTicketApi() {
            getOAuthTpTicket({ type: 'OAUTH_H5' }).then((res) => {
                window.localStorage.setItem('isLoginState', true)
                wxLogin(res.data.tpTicket)
            })
        },
        loginByAuthTicketApi(tpTicket) {
            userLogin({ type: 'auth_ticket', authTicket: tpTicket, appId: window.WX_APPID }).then((res) => {
                const userInfo = res.data
                if (userInfo) {
                    setUserInfo(userInfo)
                    window.location.href = this.funcUrlDel(['tpTicket'])
                } else {
                    this.$toast('登录失败')
                }
            })
        },
        funcUrlDel(names) {
            const options = urlQuery()
            const { origin, pathname } = window.location
            names.forEach((key) => {
                delete options[key]
            })
            let url = `${origin}${pathname}`
            if (Object.keys(options).length !== 0) {
                const arr = []
                Object.keys(options).forEach((key) => {
                    arr.push(`${key}=${options[key]}`)
                })
                url += '?' + arr.join('&')
            }
            return url
        },
    },
}
</script>
<style lang="scss" scoped>
.login-popup {
    :deep(.login-container) {
        width: 300px;
        height: 280px;
        .title {
            text-align: center;
            line-height: 3em;
            font-size: 20px;
            font-weight: 700;
        }
        .tel-code {
            margin-top: 12px;
            padding: 0 24px;
            .item {
                background: #f5f5f5;
                border-radius: 4px;
                border: 1px solid #e6e6e6;
                font-size: 16px;
                line-height: 16px;
                display: flex;
                align-items: center;
                position: relative;
                box-sizing: border-box;
                width: 252px;
                height: 36px;
                margin-bottom: 24px;
                padding: 0 16px;
            }
            input {
                background: #f5f5f5;
                border: none;
                width: 60%;
                color: #333333;
                font-size: 14px;
                line-height: 14px;
            }
            .code-btn {
                width: 80px;
                height: 36px;
                background: #44cd94;
                border-radius: 0px 4px 4px 0px;
                font-size: 13px;
                color: #ffffff;
                line-height: 14px;
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                right: 0;
                top: 0;
                cursor: pointer;
            }
            .disabled-state {
                color: #666666;
                background: #eeeeee;
            }
            .login-btn:active {
                opacity: 0.9;
            }
            .login-btn {
                background: #ffffff;
                color: #ffffff;
                background: #44cd94;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 240px;
                height: 36px;
                border-radius: 4px;
                font-weight: 700;
                font-size: 16px;
                margin: 36px auto 24px;
            }
        }
        .agm {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            color: #99948d;
            line-height: 20px;
            a {
                color: #2440b3;
            }
        }
    }
}
.verification-popup {
    width: 280px;
    height: 180px;
    border-radius: 4px;
    .container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 36px auto 10px;
        .verification-img {
            width: 100px;
            height: 40px;
            margin-right: 10px;
        }
        .van-icon-replay {
            cursor: pointer;
            font-size: 18px;
        }
        input {
            margin-left: 24px;
            height: 28px;
            width: 80px;
            border: 1px solid #dedede;
            display: block;
            border-radius: 4px;
            padding: 4px 8px;
            text-align: center;
        }
    }
}
.opts {
    display: flex;
    justify-content: space-between;
    padding: 28px 40px 0;
    > div {
        width: 90px;
        height: 28px;
        border-radius: 4px;
        font-size: 13px;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
        box-sizing: border-box;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .close-btn {
        border: 1px solid #e6e6e6;
        background: #ffffff;
        color: #606266;
    }
    .submit-btn {
        color: #ffffff;
        background: #44cd94;
    }
}
</style>
